const Fieldset = ({ classes, children }) => {
  return (
    <div className={`ds-header__form-wrapper ${classes ? classes : ""}`}>
      <fieldset className={`ds-header__form-group ${classes ? classes : ""}`}>
        <legend className="ds-header__form-legend">dados para acesso</legend>
        {children}
      </fieldset>
    </div>
  )
}
export default Fieldset
